import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";

function AdmissionDetails() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Admission Details</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Admission Details</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Admission Details</h1>
                        </div>
                        <div class="col-12 admission">
                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/admission.png"
                                class="d-block" alt="SMNS Bokaro" />
                            <h3 class="subhead">Admission Overview</h3>
                            <p>Admissions are primarily conducted for the Pre-Nursery class. Every child admitted to Pre-Nursery continues through a three-year learning journey at SMNS: Pre-Nursery → Nursery → Prep. </p>
                            <p>There is no written test for Pre-Nursery admission. We assess the general intelligence and readiness of the child, focusing on their ability to adapt to the academic and social environment of the school rather than subject-specific knowledge.</p>
                            <p>Admissions to Nursery and Prep classes are considered based on availability of vacancies.</p>
                            <p>Upon successful completion of Prep at SMNS, children are eligible for direct admission to Class 1 at M.G.M. Higher Secondary School, Sector 4/F, Bokaro.</p>

                            <div class="clr30"></div>
                            <h3 class="subhead">Documents Required for Admission</h3>
                            <ul className="checklist">
                                <li><b>Birth Certificate:</b> Self-attested photocopy issued by the Registrar of Birth & Death.</li>
                                <li><b>Aadhaar Card:</b> Self-attested copies of child, father, and mother.</li>
                                <li><b>Address Proof:</b> Self-attested photocopy of a valid government-issued ID (Driving License, Passport, Voter ID, etc.).</li>
                                <li><b>Photographs:</b> Recent passport-size photographs of the child, mother, father, and guardian.</li>
                                <li><b>Caste Certificate (if applicable):</b> Self-attested photocopy.</li>
                                <li><b>Physically Challenged Child (if applicable):</b> Relevant documents.</li>
                                <li><b>Sibling Status (if applicable):</b> Photocopy of the sibling’s school diary particulars page or School ID.</li>
                            </ul>
                            <div class="clr30"></div>
                            <h3 class="subhead">Age Criteria (as on 1st April of Academic Session)</h3>
                            <ul className="checklist">
                                <li><b>Pre-Nursery:</b> 2 years – 3 years 6 months</li>
                                <li><b>Nursery:</b> 3 years 6 months – 5 years</li>
                                <li><b>Prep:</b> 4 years 6 months – 6 years</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default AdmissionDetails